<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Freshdesk" class="d-icon d-icon--freshdesk" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`"><path d="M20.976 0A3.002 3.002 0 0 1 24 3.027v9.011C24 18.646 18.645 24 12.037 24h-.068A11.959 11.959 0 0 1 0 12.041C0 5.414 5.346.068 11.963.001h9.013Zm-9.022 5.35a5.486 5.486 0 0 0-5.487 5.492v3.736c.021 1 .827 1.807 1.827 1.828h1.554v-4.293h-2.1v-1.199a4.27 4.27 0 0 1 4.262-4.028 4.263 4.263 0 0 1 4.256 4.028v1.2h-2.13v4.295h1.405v.069a1.713 1.713 0 0 1-1.688 1.687h-1.677c-.137 0-.286.068-.286.204a.301.301 0 0 0 .286.286h1.687a2.195 2.195 0 0 0 2.182-2.181v-.137a1.8 1.8 0 0 0 1.404-1.772v-3.94c-.085-2.959-2.483-5.275-5.495-5.275Z" fill="#25C16F"/><path d="M11.955 5.349a5.486 5.486 0 0 0-5.487 5.492v3.736c.021 1 .827 1.807 1.827 1.828h1.554v-4.293h-2.1v-1.199a4.27 4.27 0 0 1 4.262-4.028 4.263 4.263 0 0 1 4.256 4.028v1.2h-2.13v4.295h1.405v.069a1.713 1.713 0 0 1-1.688 1.687h-1.677c-.137 0-.286.068-.286.204a.301.301 0 0 0 .286.286h1.687a2.195 2.195 0 0 0 2.182-2.181v-.137a1.8 1.8 0 0 0 1.404-1.772v-3.94c-.085-2.959-2.483-5.275-5.495-5.275Z" fill="#fff"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h24v24H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFreshdesk',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
